import { QuestionExplanation } from '../../types'

// Import all explanation modules
export { METRIEK_EXPLANATIONS } from './metriek'
export { GETALBEGRIP_EXPLANATIONS } from './getalbegrip'
export { TIJDGELD_EXPLANATIONS } from './tijdgeld'
export { SPELLINGWW_EXPLANATIONS } from './spellingww'
export { SPELLINGREGEL_EXPLANATIONS } from './spellingregel'
export { TAALBEGRIP_EXPLANATIONS } from './taalbegrip'
